module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages fx content"
  }, [_c('section', {
    staticClass: "phone-show fx-shrink"
  }, [_c('h3', [_vm._v("会员卡")]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-cont"
  }, [_c('div', {
    staticClass: "fx"
  }, [_c('div', {
    staticClass: "fx fx-y-center fx-fill"
  }, [_c('div', {
    staticClass: "logo-pic"
  }, [_c('img', {
    attrs: {
      "src": _vm.logo
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-l-10 card-name"
  }, [_c('p', {
    staticClass: "text-ellipsis w120"
  }, [_vm._v(_vm._s(_vm.userInfo.username || '请完善商户名称'))]), _vm._v(" "), _c('p', {
    staticClass: "m-t-5"
  }, [_vm._v(_vm._s(_vm.params.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-code-simple fx-shrink"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-num"
  }, [_vm._v("1234 5678 9101")])]), _vm._v(" "), _c('div', {
    staticClass: "card-pic"
  }, [_c('img', {
    attrs: {
      "src": _vm.params.face
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-info"
  }, [_c('ul', {
    staticClass: "fx fx-y-center"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "fx-fill"
  }, [_c('h4', [_vm._v("折扣")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("formatDscount")(_vm.params.discount)))])])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('section', {
    staticClass: "menu-edit b-r-5 fx-fill"
  }, [(_vm.params.id) ? _c('div', {
    staticClass: "m-b-20"
  }, [_c('div', {
    staticClass: "fx fx-y-center"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "fx-fill"
  }, [_vm._v("https://open.pixiugj.com/vip_card?mid=" + _vm._s(_vm.userInfo.mid) + "&scope=snsapi_userinfo")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w400"
  }, [_c('z-input', {
    attrs: {
      "title": "会员卡名称",
      "maxlength": "8",
      "isMust": "true",
      "placeholder": "会员卡名称最多8个字"
    },
    model: {
      value: (_vm.params.title),
      callback: function($$v) {
        _vm.$set(_vm.params, "title", $$v)
      },
      expression: "params.title"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fx m-t-20"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-bg fx-fill"
  }, [_c('ul', {
    staticClass: "fx fx-wrap"
  }, _vm._l((_vm.face_list), function(item) {
    return _c('li', {
      class: {
        'active': _vm.params.face == item.url
      },
      on: {
        "click": function($event) {
          return _vm.handleChooseFace(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.url
      }
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "w400 m-t-15"
  }, [_c('div', {
    staticClass: "fx fx-y-center "
  }, [_c('z-input', {
    attrs: {
      "title": "会员折扣",
      "isMust": "true",
      "placeholder": "例：95折输入95",
      "type": "number"
    },
    model: {
      value: (_vm.params.discount),
      callback: function($$v) {
        _vm.$set(_vm.params, "discount", $$v)
      },
      expression: "params.discount"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "m-l-5"
  }, [_vm._v("折")])], 1), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('section', {
    staticClass: "integral-cont"
  }, [_c('div', {
    staticClass: "fx m-t-20"
  }, [_vm._m(5), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\t每消费 "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.cost_money_unit),
      expression: "params.cost_money_unit"
    }],
    staticClass: "m-r-5 m-l-5 b-r-5 input-money",
    attrs: {
      "type": "text",
      "name": "",
      "id": ""
    },
    domProps: {
      "value": (_vm.params.cost_money_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "cost_money_unit", $event.target.value)
      }
    }
  }), _vm._v("元，\n\t\t\t\t\t增加"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.increase_bonus),
      expression: "params.increase_bonus"
    }],
    staticClass: "input-money m-r-5 m-l-5 b-r-5",
    attrs: {
      "type": "text",
      "name": "",
      "id": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.params.increase_bonus)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "increase_bonus", $event.target.value)
      }
    }
  }), _vm._v("积分\n\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: " m-t-20"
  }, [_c('z-input', {
    attrs: {
      "title": "使用说明",
      "type": "textarea",
      "isMust": "true",
      "placeholder": "上面会员权益如已经填写“会员折扣”“会员积分”的内容，将会在会员卡详情展示，无需重复填写。“使用说明”可以填写其他会员特权，例如：100积分可以抵扣1元现金；积分可以参与抽奖、实物兑换等。"
    },
    model: {
      value: (_vm.params.description),
      callback: function($$v) {
        _vm.$set(_vm.params, "description", $$v)
      },
      expression: "params.description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w400 m-t-20"
  }, [_c('z-input', {
    attrs: {
      "type": "tel",
      "title": "客服电话",
      "placeholder": "请填写客服手机号",
      "maxlength": "11"
    },
    model: {
      value: (_vm.params.service_phone),
      callback: function($$v) {
        _vm.$set(_vm.params, "service_phone", $$v)
      },
      expression: "params.service_phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fx m-t-20"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "fx-fill m-l-5"
  }, [_c('div', {
    staticClass: "fx"
  }, [_c('label', {
    staticClass: "fx fx-y-center m-r-20"
  }, [_c('input', {
    staticClass: "radio m-r-5 b-r-50",
    attrs: {
      "type": "radio",
      "name": "switch",
      "id": "",
      "value": ""
    },
    domProps: {
      "checked": _vm.params.status == 1 ? true : false
    },
    on: {
      "click": _vm.handleStatus
    }
  }), _vm._v(" "), _c('span', [_vm._v("开启")])]), _vm._v(" "), _c('label', {
    staticClass: "fx fx-y-center"
  }, [_c('input', {
    staticClass: "radio m-r-5 b-r-50",
    attrs: {
      "type": "radio",
      "name": "switch",
      "id": "",
      "value": ""
    },
    domProps: {
      "checked": _vm.params.status == 0 ? true : false
    },
    on: {
      "click": _vm.handleStatus
    }
  }), _vm._v(" "), _c('span', [_vm._v("关闭")])])]), _vm._v(" "), _c('p', {
    staticClass: "m-t-5 c-g"
  }, [_vm._v("Tips：会员卡状态为关闭时，停止所有用户使用，并停止领取。")])])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-20 fx"
  }, [_c('p', {
    staticClass: "w120 m-r-5 fx-shrink"
  }), _vm._v(" "), _c('a', {
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": _vm.handleCreateMemberCard
    }
  }, [_vm._v("保存")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "fx-fill"
  }, [_c('h4', [_vm._v("积分")]), _vm._v(" "), _c('p', [_vm._v("0")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-menu"
  }, [_c('ul', {
    staticClass: "fx"
  }, [_c('li', {
    staticClass: "fx-fill"
  }, [_c('div', {
    staticClass: "fx-align"
  }, [_c('i', {
    staticClass: "icon-vipcard"
  })]), _vm._v(" "), _c('p', [_vm._v("会员卡详情")])]), _vm._v(" "), _c('li', {
    staticClass: "fx-fill"
  }, [_c('div', {
    staticClass: "fx-align"
  }, [_c('i', {
    staticClass: "icon-store"
  })]), _vm._v(" "), _c('p', [_vm._v("适用门店")])]), _vm._v(" "), _c('li', {
    staticClass: "fx-fill"
  }, [_c('div', {
    staticClass: "fx-align"
  }, [_c('i', {
    staticClass: "icon-info-edit"
  })]), _vm._v(" "), _c('p', [_vm._v("个人资料")])]), _vm._v(" "), _c('li', {
    staticClass: "fx-fill"
  }, [_c('div', {
    staticClass: "fx-align"
  }, [_c('i', {
    staticClass: "icon-coupon"
  })]), _vm._v(" "), _c('p', [_vm._v("优惠券")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title fx w120 m-r-5"
  }, [_c('p', {
    staticClass: "ask-cont"
  }), _vm._v(" "), _c('span', [_vm._v("前台地址")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w120 fx-shrink m-r-5 m-t-5 fx"
  }, [_c('i', {
    staticClass: "ask"
  }, [_vm._v("*")]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("会员卡封面")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fx m-t-5"
  }, [_c('p', {
    staticClass: "w120 fx-shrink m-r-5"
  }), _vm._v(" "), _c('p', {
    staticClass: "pic-tips"
  }, [_vm._v("Tips：折扣值必须是1-99的整数")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w120 fx-shrink m-r-5 m-t-5 fx"
  }, [_c('i', {
    staticClass: "ask"
  }, [_vm._v("*")]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("积分规则")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "w120 fx-shrink fx"
  }, [_c('i', {
    staticClass: "ask"
  }, [_vm._v("*")]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("会员卡状态")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3da99b2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/vip_card/VipManage.vue
// module id = 832
// module chunks = 0